
import React from 'react';
import { motion } from "framer-motion";

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1 }
};

export const CareerProgressionStepContent: React.FC = () => {
  return (
    <motion.div 
      className="mt-4 flex-grow"
      variants={itemVariants}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-3 mb-4">
        {['Junior', 'Mid-Level', 'Senior', 'Leader'].map((level, index) => (
          <div key={level} className="relative w-full">
            <div className="text-center p-4 bg-web3-blue/10 rounded-md relative">
              <div className={`text-xl font-medium ${index === 0 ? 'text-web3-green' : 'text-white/80'}`}>
                {level}
              </div>
              <div className="text-xs text-white/60">
                {index === 0 && 'Starting Level'}
                {index === 3 && 'Goal'}
              </div>
            </div>
            {index < 3 && (
              <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10 text-web3-green text-2xl">
                →
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="p-4 bg-web3-green/10 rounded-md border border-web3-green/30 text-center">
        <p className="text-white/90">
          Your career progression depends on <span className="text-web3-green font-bold">experience points</span> and 
          <span className="text-web3-green font-bold"> years of service</span>. Make smart decisions to advance faster!
        </p>
      </div>
    </motion.div>
  );
};
